module.exports = __webpack_public_path__ + "b9ff59f6ef2276f8efec0d6751910f68.png";